import React from "react";
import Select from "./select";
import Option from "./option";

export default function CountrySelect(props) {
  const { countries, ...rest } = props;
  return (
    <Select {...rest}>
      {countries.map(([code, name], idx) => (
        <Option key={idx} value={code}>
          {name}
        </Option>
      ))}
    </Select>
  );
}
